import { Component, Inject } from '@angular/core';
import { ImagePreviewData } from '@shared/components/image-preview-dialog/image-preview-data';
import { ImagePreviewDialogComponent } from '@shared/components/image-preview-dialog/image-preview-dialog.component';
import { DialogService } from '@shared/services/dialog.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

@Component({
  selector: 'miq-image-preview-cell-renderer',
  template: ` <mat-icon *ngIf="hasData" svgIcon="icon-image" class="file-icon" (click)="onIconClick($event)">
  </mat-icon>`,
  styles: [
    `
      .file-icon {
        cursor: pointer;
      }
    `,
  ],
  standalone: false,
})
export class ImagePreviewCellRendererComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  hasData = false;
  mediaInfo: Record<string, any>[] = [];

  constructor(
    private notificationService: DialogService,
    @Inject(CbreLoggerToken) private logger: CbreLogger
  ) {}

  agInit(params: ICellRendererParams): void {
    // Initialize the cell renderer with the provided parameters
    // Check if a valueGetter is defined in the column definition
    const data =
      typeof params.colDef.valueGetter === 'function'
        ? params.colDef.valueGetter(params as ValueGetterParams<any>)
        : [];
    this.params = params;
    this.hasData = data.length > 0;
    this.mediaInfo = data;
  }

  refresh(params: ICellRendererParams): boolean {
    const data =
      typeof params.colDef.valueGetter === 'function'
        ? params.colDef.valueGetter(params as ValueGetterParams<any>)
        : [];
    if (data > 0) {
      this.params = params;
      this.mediaInfo = data;
      return true;
    }
    return false;
  }

  onIconClick(event: Event): void {
    event.stopPropagation();
    if (this.mediaInfo?.length > 0) {
      const data: ImagePreviewData = {
        imagesMedia: this.mediaInfo,
        selectedImageId: this.mediaInfo[0].id,
        disableBGCoverImage: true,
        title: 'recordsSearch.preview.' + this.params?.data?.entity?.entity_type,
      };
      this.notificationService.openDialog(ImagePreviewDialogComponent, data, {
        height: '93vw !important',
        panelClass: 'table-modals',
      });
    } else {
      this.logger.error('No media info available');
    }
  }
}
